import { drop } from 'lodash';
import React, { Component } from 'react';
type IFooterProps = {
  clearAll?: () => void;
  closeFilter: () => void;
  handleApply?: () => void;
  clearText?: string;
  customClass?: any;
  showApply?: boolean;
  showClearAll?: boolean;
  onSearchbuttonClick: () => void;
  handleApplyOnFilters: (dropDownflags: any) =>void;
  dropDownflags: any
};
const DropdownFooter = ({
  clearAll,
  closeFilter,
  handleApply,
  customClass,
  showApply = false,
  showClearAll = true,
  clearText = 'Clear filters',
  onSearchbuttonClick,
  handleApplyOnFilters,
  dropDownflags
}: IFooterProps) => {

  const onApply = () => {
    closeFilter();
    handleApplyOnFilters(dropDownflags);
    onSearchbuttonClick()
  }

  return (
    <div className={customClass ? customClass : 'filter-footer'}>
      {showClearAll && (
        <button id='clearAll' className='btn clear-all-btn' data-tfs='clearAll' onClick={clearAll}>
          {clearText}
        </button>
      )}

      <button
        id='close-btn'
        className='btn sector-dropdown-btn'
        data-tfs='close-btn'
        onClick={onApply}>
        Apply
      </button>

      {showApply && (
        <button
          id='close-btn'
          className='btn sector-dropdown-btn'
          data-tfs='close-btn'
          onClick={handleApply}>
          Apply
        </button>
      )}
    </div>
  );
};

export default DropdownFooter;
